import React from "react";
//import { useState } from "react";
import { useTranslation } from "react-i18next";
// import { Trans } from "react-i18next";

//Component helpers
import EnterpriseBenefits from "./EnterpriseBenefits";

//Other Imports
import "./Enterprise.scss";
import WhiteLabelIntro from "@pages/Other/WhiteLabelIntro";
import WhoIsUsingUs from "@pages/Other/WhoIsUsingUs";
import EnterpriseIntro from "@pages/Other/EnterpriseIntro";
import { Link } from "react-router-dom";
import GetStarted from "./GetStarted";

function EnterprisePage() {
  const { t } = useTranslation();

  return (
    <div className="EnterprisePage">
      {/* Componentize this! TODO */}
      <div className="EnterpriseBanner">
        <div className="inner-wrapper">
          <div className="animate-from-bottom">
            <div className="enterprise-title-desc">
              <h1>{t("For Enterprise Title")}</h1>
              <p>{t("For Enterprise Description")}</p>
            </div>
            <div className="signup-plans-buttons">
              <div className="button-wrapper-signup">
                <div className="btn-signup cta">
                  <Link to={{ pathname: "/pricing", state: "lite" }}>
                    <span>Sign up, It's free</span>
                  </Link>
                </div>
              </div>
              <div className="button-wrapper-plans">
                <div className="btn-plans cta">
                  <Link to="/pricing">
                    <span>Plans & Pricing</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="image-wrapper animate-from-right"></div>
      </div>

      <EnterpriseIntro />
      {/* <WhoIsUsingUs /> */}
      <WhiteLabelIntro />
      <EnterpriseBenefits />
      <GetStarted />
    </div>
  );
}

export default EnterprisePage;
